import React from 'react';
import { ArrowRight, CalendarDays, Focus, MessageSquare, Sparkles } from 'lucide-react';

const durationOptions = [3, 5, 7, 14];

const PrayerGuideForm = ({
    theme,
    setTheme,
    focus,
    setFocus,
    duration,
    setDuration,
    additionalInfo,
    setAdditionalInfo,
    handleSubmit,
    isGenerating,
}) => (
    <form onSubmit={handleSubmit} className="guide-builder-form">
        <label>
            <span><Sparkles size={16} /> Theme</span>
            <input
                id="theme"
                type="text"
                value={theme}
                maxLength={160}
                onChange={(event) => setTheme(event.target.value)}
                placeholder="Peace, guidance, strength..."
                required
            />
            <small>The truth or quality you want to return to.</small>
        </label>

        <label>
            <span><Focus size={16} /> Focus area</span>
            <input
                id="focus"
                type="text"
                value={focus}
                maxLength={240}
                onChange={(event) => setFocus(event.target.value)}
                placeholder="A decision, relationship, season..."
                required
            />
            <small>The specific part of life you want to pray through.</small>
        </label>

        <fieldset>
            <legend><CalendarDays size={16} /> Length of guide</legend>
            <div className="guide-duration-options">
                {durationOptions.map((days) => (
                    <button
                        type="button"
                        key={days}
                        className={duration === days ? 'is-selected' : ''}
                        onClick={() => setDuration(days)}
                    >
                        <strong>{days}</strong>
                        <span>days</span>
                    </button>
                ))}
            </div>
        </fieldset>

        <label>
            <span><MessageSquare size={16} /> A little more context <em>Optional</em></span>
            <textarea
                id="additionalInfo"
                value={additionalInfo}
                maxLength={2000}
                onChange={(event) => setAdditionalInfo(event.target.value)}
                placeholder="Share any names, questions, or circumstances you would like the guide to hold..."
                rows={4}
            />
        </label>

        <button type="submit" className="guide-generate-button" disabled={isGenerating}>
            <span>
                <small>{isGenerating ? 'Creating your path' : `${duration} days of scripture & prayer`}</small>
                <strong>{isGenerating ? 'Generating guide...' : 'Create my prayer guide'}</strong>
            </span>
            <ArrowRight size={20} />
        </button>
    </form>
);

export default PrayerGuideForm;
